/*
 * Source context provider.
 * Used by blocks to know where do they belong:
 * - standalone
 * - notebook
 * - report
 *
 */
import React, {FunctionComponent, createContext, useContext, useMemo} from 'react';

import {CONTEXT_TYPE} from './constants';

interface SourceContextContent {
  type: CONTEXT_TYPE | null; // null means standalone
  uid: string | null; // source uid
}

export const SourceContext = createContext<SourceContextContent>({
  type: null,
  uid: null,
});

interface SourceProviderProps extends SourceContextContent {
  children: any;
}

export const BlockSourceProvider: FunctionComponent<SourceProviderProps> = ({
  type = null,
  uid = null,
  children,
}: SourceProviderProps) => {
  const value = useMemo(() => ({type, uid}), []);

  return (
    <SourceContext.Provider value={value}>
      {children}
    </SourceContext.Provider>
  )
};

export const useSourceType = () => {
  const {type} = useContext(SourceContext);
  return type;
};

export const useSourceId = () => { // id / uid
  const {uid} = useContext(SourceContext);
  return uid;
};
